// A user's Wheel avatar FRAME (header account avatar, Gallery Profile Card)
// must reflect their Primary Wheel (Gordon law all-avatars-wheel-frames — the
// frame is tied to the wheel the creator has actually chosen to feature).
//
// BUG FIX (ISP-9999, 2026-08-20): the account avatar (Wrapper/index.jsx) and
// the Gallery Profile Card (pages/Gallery/index.jsx) both fed their avatar
// frame exclusively from `getLatestWheelToShowInReferModal` — an endpoint
// built for the referral/invite modal's "latest wheel" pick, not the Primary
// Wheel. Both already had the real Primary Wheel selected via
// `selectPrimaryWheel` sitting unused. This picks the Primary Wheel first;
// the previously-fetched wheel (the first gallery wheel available to that
// surface) is only a fallback when the profile has no Primary Wheel set.
export function selectAvatarWheelSegments(primarySegments, fallbackSegments) {
  if (Array.isArray(primarySegments) && primarySegments.length > 0) {
    return primarySegments;
  }
  if (Array.isArray(fallbackSegments) && fallbackSegments.length > 0) {
    return fallbackSegments;
  }
  return null;
}
